import { ConfigClass } from '../../../utils/config';
export const config = new ConfigClass();
export const SKU_REGEXP = /(?:[^-]+-){4}(.+)/;
